export default {"src":"/_next/static/media/visual-mob.ebf2a01c.svg","height":269,"width":486,"blurWidth":0,"blurHeight":0};